<template>
    <v-container v-if="getData && data && data.OPAN_N" :style="`padding: ${screen_width > 959 ? '0 30px' : screen_width > 599 ? '0' : '0'};`">
        <v-card :style="`padding: ${screen_width > 599 ? '10px 20px' : '0'}`">
            <v-alert
                text
                color="#4ABAA4"
                style="border-left: 8px solid #4ABAA4;"
            >
                <div style="color: black; text-align: justify;">
                    Your request for revalidation of annual check up on {{ data.CLINIC_NAME }} was approved.
                    The approved eOPAN is now available for download by clicking the button below.
                    The eOPAN will also be sent in your registered email or can be downloaded from the History page. This eOPAN is issued {{ moment(data.APPR_D).format('DD MMMM YYYY') }} and is valid until {{ moment(data.VALI_D).format('DD MMMM YYYY') }}.
                </div>
            </v-alert>
            <v-row :style="`margin: ${screen_width > 599 ? '10px 17px' : '10px 0'};`">
                <v-col cols="12" sm="6">
                    <span style="display: block; color: #555;">OPPA NO:</span><b>{{ data.OPAN_N }}</b>
                </v-col>
                <v-col cols="12" sm="6">
                    <span style="display: block; color: #555;">Status:</span><b style="color: #00BA94;">{{ data.APPROVE ? 'APPROVED' : 'DISAPPROVED' }}</b>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-divider class="d-sm-none my-3" /><span style="display: block; color: #555;">Date Issued:</span><b>{{ formatDate(data.APPR_D) }}</b>
                </v-col>
                <v-col cols="12" sm="6">
                    <span style="display: block; color: #555;">Valid Until:</span><b>{{ formatDate(data.VALI_D) }}</b>
                </v-col>
            </v-row>
            <v-card :style="`padding: ${screen_width > 599 ? '28px' : '0 10px'}; background-color: #F9F9F9;`">
                <v-row>
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">Medical Provider:</span><b>{{ data.CLINIC_NAME }}</b>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-divider class="d-sm-none my-3" />
                        <div>
                            <span style="display: block; color: #555;">Patient Name:</span><b>{{ data.MEMB.LAST_M }}</b>
                        </div>
                        <div class="mt-4">
                            <span style="display: block; color: #555;">Date of Birth:</span><b>{{ formatDate(data.MEMB.BIRT_D) }}</b>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
            <p :style="`margin: ${screen_width > 599 ? '28px' : '30px 10px 10px 10px'}; font-size: 16px; color: #222; text-align: justify;`">
                <v-icon color="orange">
                    {{ mdiAlert }}
                </v-icon>&nbsp;Disclaimer: The approval for the referenced service or treatment is provisional. If, upon further review, it is determined that the service or treatment is not eligible for coverage under your health card plan, you may be billed back for any or all costs incurred.
            </p>
            <v-container v-if="data.OPAN_N" style="text-align: center;">
                <v-btn class="teal white--text" style="margin: 10px;" @click="fetchFile">
                    <v-icon>{{ mdiDownload }}</v-icon>&nbsp;
                    <h1>Download</h1>
                </v-btn>
                <v-btn @click="goBack()">
                    <h1>Done</h1>
                </v-btn>
                <h1 style="color: #00BA94;">
                    Should you need assistance, kindly contact <a style="color: #00BA94" href="https://www.hmi.com.ph/contact">HMI</a>.
                </h1>
            </v-container>
        </v-card>
    </v-container>
    <!-- <h2 class="headerName">{{ headerName }}</h2>
    <p><strong>This request has been <span :class="consultationStatus === 'revalidated' ? 'revalidated' : 'disapproved'">{{ consultationStatus.toUpperCase() }}</span>!</strong></p>
    <section>
        <h2 class="headerName">Details</h2>
        <ul style="margin-bottom: 15px;">
            <li><strong>Patient:</strong> {{ patientName }} (Birthdate: {{ birthdate }}, Gender: {{ sex }})</li>
            <li><strong>Medical Provider:</strong> {{ data.CLINIC_NAME }}</li>
            <li><strong>Date Issued:</strong> {{ approveDate }}</li>
            <li><strong>Valid Until:</strong> {{ validDate }}</li>
            <li v-if="consultationStatus === 'approved'"><strong>Valid Until:</strong> {{ validDate }}</li>
            <li><strong>Contract Number:</strong> {{ contractNo }}</li>
        </ul>
    </section>
    <template v-if="data.APPROVE">
        <h2 class="headerName">Authorization</h2>
        <p>The Annual Check-Up slip for {{ patientName }} has been generated.</p>
        <v-btn
            @click="fetchFile"
            style="margin-bottom: 20px; background-color: #009688; color: white;"
        ><v-icon>{{mdiDownload}}</v-icon>DOWNLOAD AUTHORIZATION SLIP</v-btn>
    </template>
    <template v-else><v-alert type="error">{{ data.REMA }}</v-alert></template>
    <p><strong>Disclaimer: </strong>The approval for the referenced service or treatment is provisional. If, upon further review, it is determined that the service or treatment is not eligible for coverage under your health card plan, you may be billed back for any or all costs incurred.</p>
    <p><strong>For further inquiries :</strong> Please contact HMI directly at (02) 8811-1313, (02) 7752-0552 and (02) 8865-3700.</p>
    <div style="display: block; text-align: center;"><v-btn class="hmiContact elavation-5" style="font-weight: 600" @click="$router.push('/dashboard/annual-physical-exam')">done</v-btn></div> -->
</template>

<script>
import { saveAs } from 'file-saver'
import { mapActions, mapGetters } from 'vuex'
import { moment } from '../../../../utils/date-shim'
import { mdiAlert, mdiDownload } from '@mdi/js'
import { base64ToBlob } from '../../../../utils/helpers'
export default {
    props: ['data'],
    data: ()=>({
        mdiAlert, 
        mdiDownload,
        fileUrlData: null,
        contractNo: null,
        validDate: null,
        approveDate: null,
        sex: null,
        birthdate: null,
        patientName: null,
        consultationStatus: null,
        headerName: null,
        consultationResult: null,
        pdfData: null,
        result: null,
        validUntil: null,
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['file']),
        getData() {
            if (this.data) this.fetchData(this.data)
            return true
        }
    },
    watch: {
        file(newVal) {
            if (newVal) {
                this.pdfData = { url: newVal.file, type: 'application/pdf', fileName: this.$cookies.get('usermembn') + '-' + this.data.OPAN_N + '-' + 'APE' }
                this.download()
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['fetchSlip']),
        goBack() {
            this.$router.push('/dashboard/annual-physical-exam')
        },
        formatDate(date) {
            return moment(date).utcOffset('+0800').format('DD MMMM YYYY')
        },
        fetchFile() {
            this.loading = true
            this.fetchSlip({
                OPPAN_PDF_NAME: this.data.OPAN_N,
                MEMBN: this.$cookies.get('usermembn')
            })
        },
        async download() {
            this.loading = true
            try {
                const { url, type, fileName } = this.pdfData
                const blob = base64ToBlob(url, type)
                saveAs(blob, `${fileName}.pdf`)
            } catch (error) {
                console.error('Something went wrong: ' + error.message)
                throw error
            } finally {
                this.loading = false
            }
        },
        fetchData(data) {
            this.contractNo = `${data.MEMB_N}-${data.MEMB && data.MEMB.PROG_C}`
            this.validDate = moment(data.VALI_D).format('D MMMM, YYYY')
            this.approveDate = moment(data.APPR_D).format('D MMMM, YYYY')
            this.sex = data.MEMB.SEX === 'F' ? 'FEMALE' : 'MALE'
            this.birthdate = moment(data.MEMB.BIRT_D).format('D MMMM YYYY')
            this.patientName = `${data.MEMB.LAST_M} ${data.MEMB.MIDI_M ? data.MEMB.MIDI_M[0] : ''}`
            this.consultationStatus = data.APPROVE ? 'revalidated' : 'disapproved'
            this.headerName = 'Annual Check-Up Revalidation '
            this.headerName += data.APPROVE
                ? `Approved (ACU No.: ${data.OPAN_N})`
                : 'Disapproved'

            const pdf = data && data.CRF_PDF ? data.CRF_PDF : null
            if (pdf) this.fetchPdf(pdf, `${data.MEMB_N}-${data.APPR_D}`)
            this.consultationResult = data
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 18px;
}
</style>
